import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineHistory } from "react-icons/ai";
import { HiOutlineViewGrid } from "react-icons/hi";
import { IoHomeOutline } from "react-icons/io5";
import { SiMqtt } from "react-icons/si";
import { GrTransaction } from "react-icons/gr";
import { IoSettings } from "react-icons/io5";

import {
  UserSVG,
  User2SVG,
  FleetSVG,
  AddDeviceSVG,
  OTAUpdate,
  Logger,
  AlertRules,
  ViewAlerts,
  AdvertisementSVG,
} from "./SVGIcon";

export let svgs = {
  IoHomeOutline: <IoHomeOutline />,
  UserSVG: <UserSVG />,
  User2SVG: <User2SVG />,
  HiOutlineViewGrid: <HiOutlineViewGrid />,
  FleetSVG: <FleetSVG />,
  AddDeviceSVG: <AddDeviceSVG />,
  AiOutlineHistory: <AiOutlineHistory />,
  OTAUpdate: <OTAUpdate />,
  JsonConfigs: <IoSettings />,
  SiMqtt: <SiMqtt />,
  Logger: <Logger />,
  AlertRules: <AlertRules />,
  ViewAlerts: <ViewAlerts />,
  GrTransaction: <GrTransaction />,
  AdvertisementSVG: <AdvertisementSVG />,
};
const Sidebar = () => {
  const { sidebar = [] } = useSelector((state) => state.auth);

  return (
    <div className="border-r-2 border-[#D9D9D9]">
      <div className="hidden lg:block">
        <div className="leftmenu-wrapper ">
          <div
            style={{ scrollbarWidth: "thin" }}
            className="hidden lg:block overflow-x-hidden px-[10px]  h-screen "
          >
            <ul className="menu mb-6 pt-7">
              {sidebar?.map((x, i) => {
                const { name, link, svg } = x;
                return (
                  <li className="mb-0.5 effect" key={i}>
                    <NavLink
                      to={link}
                      className="px-2 py-4 text-base-600 text-[17px] font-[400] leading-[22px]"
                    >
                      <div className="flex items-center gap-2 iconsSet">
                        {svgs[svg]} <span>{name}</span>
                      </div>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
